import { ProjectResourceType } from 'src/constants/project';
import {
  LinkCategory,
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import {
  BaseData,
  FileUpload,
  Mapping,
  MappingLabel,
  ModelConceptClass,
  ModelConceptHierarchy,
  ModelConceptHierarchyLabel,
  ModelConceptRelationship,
  ModelConceptRelationshipLabel,
  RelationshipMapping,
  Resource,
  VirtualGraph,
} from 'src/containers/ProjectDiagram/types/data';

export const isResource = (data: BaseData): data is Resource => {
  return data.category === NodeCategory.RESOURCE;
};

export const isFileUpload = (data: BaseData): data is FileUpload => {
  return isResource(data) && data.type === ProjectResourceType.FILE_UPLOAD;
};

export const isVirtualGraph = (data: BaseData): data is VirtualGraph => {
  return isResource(data) && data.type === ProjectResourceType.VIRTUAL_GRAPH;
};

export const isModelConceptClass = (
  data: BaseData
): data is ModelConceptClass => {
  return data.category === NodeCategory.MODEL_CONCEPT_CLASS;
};

export const isMappingLabel = (data: BaseData): data is MappingLabel => {
  return data.category === LinkLabelCategory.MAPPING_LABEL;
};

export const isMapping = (data: BaseData): data is Mapping => {
  return data.category === LinkCategory.MAPPING;
};

export const isRelationshipMapping = (
  data: BaseData
): data is RelationshipMapping => {
  return data.category === LinkCategory.RELATIONSHIP_MAPPING;
};

export const isModelConceptRelationshipLabel = (
  data: BaseData
): data is ModelConceptRelationshipLabel => {
  return data.category === LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL;
};

export const isModelConceptRelationship = (
  data: BaseData
): data is ModelConceptRelationship => {
  return data.category === LinkCategory.MODEL_CONCEPT_RELATIONSHIP;
};

export const isModelConceptHierarchy = (
  data: BaseData
): data is ModelConceptHierarchy => {
  return data.category === LinkCategory.MODEL_CONCEPT_HIERARCHY;
};

export const isModelConceptHierarchyLabel = (
  data: BaseData
): data is ModelConceptHierarchyLabel => {
  return data.category === LinkLabelCategory.MODEL_CONCEPT_HIERARCHY_LABEL;
};
